import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as MapDrawActions from '../actions/map-draw.actions';
import { selectDrawnItems } from '../reducers';
import { MapFacade } from '../../../main/components/map/services/map.facade';

@Injectable()
export class MapDrawEffects {
	constructor(
		private actions$: Actions,
		private store: Store,
		private mapFacade: MapFacade
	) {}

	updateBounds$ = createEffect(() =>
		this.actions$.pipe(
			ofType(MapDrawActions.updateBounds),
			withLatestFrom(this.store.select(selectDrawnItems)),
			map(([_, drawnItems]) => {
				if (!drawnItems.length) return MapDrawActions.updateBoundsSuccess({ bounds: null });

				const coordinates = drawnItems.map(item => Array.isArray(item.coordinates[0]) ? item.coordinates : item.coordinates.flat(2));
				const bounds = this.mapFacade.getBoundsFromCoordinates(coordinates.flat());
				return MapDrawActions.updateBoundsSuccess({ bounds });
			})
		)
	);
}
